import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify"; // ✅ Usar react-hot-toast

export const useProducto = () => {
   const queryClient = useQueryClient();
   const token = localStorage.getItem("token");
   const baseUrl = process.env.REACT_APP_URL_DIR + "product";

   const GetProductos = () => {
        const { data } = useQuery({
            queryKey: ["producto"],
            queryFn: () =>
                fetch(baseUrl, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }).then((res) => res.json()),
            });
            if (data?.message === "Token inválido") {
                toast.error("Token inválido.Por favor vuelva a logonearse");
               return null;
            }
            return data;
    
   };
   const crearProducto = useMutation({
      mutationFn: async (productoData) => {
         const isUpdate = productoData.id > 0;
            const method = isUpdate ? "PUT" : "POST";
            const url = isUpdate
               ? `${baseUrl}/${productoData.id}`
               : `${baseUrl}`;
            const response = await fetch(url, {
                method,
                headers: {
                     Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                },
                body: JSON.stringify(productoData),
            });
            return response.json();
      },
      onSuccess: () => {
         toast.success("Producto actualizado");
      },
      onFailure: () => {
         toast.error("Error creando producto");
      },
   });


   const deleteProductos = useMutation({
      mutationFn: async (id) => {
         const response = await fetch(`${baseUrl}/${id}`, {
            method: "DELETE",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         });
         return response.json();
      },
      onSuccess: (resp) => {
         if (resp?.message) {
             toast.warn(resp.message);           
         } else {
             toast.success("Producto eliminado");
         }


         queryClient.invalidateQueries(["producto"]);
      },
      onError: () => {
         toast.error("Error eliminando producto");
      },
   });
   return { GetProductos, deleteProductos, crearProducto };
};